module.exports = __webpack_public_path__ + "img/6.de453d70.jpg";